import { useDebouncedCallback as useDebouncedCallbackFn } from 'use-debounce'

import SETTINGS from 'src/settings'

function useDebouncedCallback<CallbackType extends (...args: any[]) => ReturnType<CallbackType>>(
  callback: CallbackType,
  delay: number = SETTINGS.app.debounce_delay_on_filter_change,
  options?: Parameters<typeof useDebouncedCallbackFn>[2]
) {
  return useDebouncedCallbackFn(callback, delay, options)
}

export default useDebouncedCallback
